import { gamepadDetectionService } from "../../inputs/controller/GamepadDetectionService";
import { degToRad } from "flavr-common";
export class Condition {
    execute(_gestureModule) { }
    abort(_gestureModule) { }
}
export class GestureEnabledCondition extends Condition {
    constructor(type, enabled) {
        super();
        this.type = type;
        this.enabled = enabled;
    }
    test(module) {
        return this.enabled === module.isGestureEnabled(this.type);
    }
}
export class AngleCondition extends Condition {
    constructor(threshold) {
        super();
        this.threshold = threshold;
        this.aboveThreshold = false;
    }
    test(module) {
        const data = module.currData;
        const prevData = module.prevData;
        if (data.angle === undefined || data.startAngle === undefined || prevData.angle === undefined || prevData.startAngle === undefined) {
            this.aboveThreshold = false;
            return false;
        }
        if (this.aboveThreshold)
            return true;
        const rotation = Math.abs(data.angle - data.startAngle);
        if (this.threshold < Math.min(rotation, degToRad(360) - rotation)) {
            this.aboveThreshold = true;
            return true;
        }
        return false;
    }
}
export class FindNextControllerWithButtonCondition extends Condition {
    test(module) {
        const data = module.currData;
        if (data.primaryController && data.secondaryController)
            return false;
        const gamepads = gamepadDetectionService.gamepads;
        for (const gamepad of gamepads.values()) {
            if (data.primaryController !== gamepad && data.secondaryController !== gamepad) {
                if (module.isGrabButtonPressed(gamepad)) {
                    this.controller = gamepad;
                    return true;
                }
            }
        }
        return false;
    }
    execute(module) {
        const data = module.currData;
        if (!data.primaryController) {
            data.primaryController = this.controller;
            this.controller && (data.primaryPos = this.controller.position.clone());
        }
        else if (!data.secondaryController) {
            data.secondaryController = this.controller;
            this.controller && (data.secondaryPos = this.controller.position.clone());
        }
    }
    abort(module) {
        const data = module.currData;
        if (data.primaryController === this.controller) {
            data.primaryController = undefined;
        }
        else if (data.secondaryController === this.controller) {
            data.secondaryController = undefined;
        }
    }
}
